import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486e1f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex-ter flex-end" }
const _hoisted_3 = { class: "mr_20" }

import { t } from '@/plugins/i18n'
import { ref, watch, computed, reactive, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRequest, useGlobal } from '@/util/useLoading'
import useForm from '@/util/useForm'
import { ElMessage } from 'element-plus'
import useRules, { useRule } from '@/util/useRules'
import { addShop, updateShop } from '@/apis/user'
import { authBase, authShopify, authAmazon, authCafe24, authStores } from '@/util/useAuthShop'
import { isD2C, usePlat, useSite2Station, isJA, isKO, isEN, isMember, useCurShop } from '@/store'
import AmazonAgreement from '../static/AmazonAgreement.vue'
import ShopGuide from '@/components/guide/ShopGuide.vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import HelpTooltip from '@/components/common/helpTooltip.vue'
import CheckRadio from '@/components/checkRadio/index.vue'
import { ShopType, Site } from '@/common/const'
import { isUrl } from '@/plugins/utils'
import bus from '@/util/useBus'
import CanAddTip from './CanAddTip.vue'
import { useDebounceFn, useThrottleFn } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'shopData', 'vip'],
  emits: ['close', 'ok', 'listen', 'authAmazon'],
  setup(__props, { expose, emit }) {

const props = __props


const shopData = computed(() => props.shopData)
const isCreate = computed(() => !props.shopData?.customerShopId)
const store = useStore()

const shops = computed(() => {
  // 2023-7-13：韩国站和英国站去掉base，不对接Shopify
  return store.state.bussiness.Shops.filter((v: any) => {
    // 无平台，无站点情况
    if (!v.source || !v.site) return true
    const sourceMap: any = {
      1: 'd2c',
      2: 'b2b'
    }
    // 平台和站点都匹配上
    return v.source === (sourceMap[shopData.value?.systemSource ?? ''] ?? store.state.route.plat) && v.site.split(',').includes(store.state.route.site)
  })
})

const tips = [
  '请输入店铺所在的平台名称',
  '请输入店铺或品牌名',
  '请输入店铺访问链接',
  '请填写正确的访问令牌'
]

const model: any = reactive({})
const trigger: any = ref(null)

const canAuth = ref(false)

watch(
  shopData,
  (data) => {
    Object.keys(model).forEach((k) => {
      delete model[k]
    })
    // 如果传过来的店铺信息有值就赋值给model
    if (data) {
      canAuth.value = !!data.customerShopUrl
      Object.entries(data).forEach(([k, v]) => {
        model[k] = v
      })
    } else {
      const data = {
        customerShopPlatform: shops.value[0]?.value,
        customerShopPlatName: '',
        customerShopLogo: '',
        customerShopName: '',
        customerShopUrl: '',
        customerShopKey: '',
        accessToken: ''
      }
      Object.entries(data).forEach(([k, v]) => {
        if (['customerShopAuthStatus'].includes(k)) return
        model[k] = v
      })
    }
  },
  { immediate: true }
)

const rules = {
  customerShopName: useRules({
    message: t('请输入店铺或品牌名'),
    key: 'noblank'
  }),
  customerShopUrl: useRule('url')
}

const [loading, api] = useRequest((type?: number) => {
  // 创建或者更新店铺信息
  const api = useGlobal(isCreate.value ? addShop : updateShop)
  return api(model).then(async (res) => {
    res.data && (model.customerShopId = res.data)
    if (res.success) {
      // isCreate.value&&ElMessage.success('')
      // ElMessage.success(t(isCreate.value ? '创建店铺成功' : '店铺修改成功'))
      console.log(type, 'addShop')
      bus.emit('addShop', true)
      if (type !== 4) {
        // 亚马逊有二次弹窗不调用， 调用会导致列表刷新无法授权
        emit('close')
      }
      if (!type) {
        // 店铺授权会弹窗提示此处无需二次提示
        emit('ok', res.data ?? model.customerShopId)
      }
    }
  })
})

const toAuth = async () => {
  await authorize(model.customerShopPlatform)
  if (model.customerShopPlatform === ShopType.BASE) {
    authBase(model)
    emit('close')
    emit('listen')
  } else if (model.customerShopPlatform === ShopType.STORE) {
    authStores(model)
    emit('listen')
  } else if (model.customerShopPlatform === ShopType.SHOPIFY) {
    if (model.accessToken && model.customerShopUrl) {
      formRef.value.validate(async (valid: any) => {
        if (valid) {
          loading.value = true
          await authShopify(model).then((res: any) => {
            if (res) {
              emit('close')
              emit('ok')
            }
          })
          loading.value = false
        }
      })
    } else {
      ElMessage.error(t('店铺url和访问令牌不能为空'))
    }
  } else if (model.customerShopPlatform === ShopType.AMAZON) {
    emit('authAmazon')
  } else if (model.customerShopPlatform === ShopType.CAFE) {
    authCafe24(model)
    emit('close')
    emit('listen')
  } else if (model.customerShopPlatform === ShopType.TIKTOK) {
    const clientID = '7512709085121218309'
    location.href = `https://seller-jp.tiktok.com/services/market/custom-authorize/${clientID}?prev=independent&open=true&shop_region=JP&state=${model.customerShopId}`
  }
}

const shopGuideModalVisible = ref(false)
const shopsList = computed(() => store.getters.userShops)
const closeModal = () => {
  shopGuideModalVisible.value = !shopGuideModalVisible.value
}
const [formRef, authorize] = useForm(api)

const canAddTip = ref()

/** 创建或修改店铺 */
const commit = useThrottleFn(async () => {
  if (!canAddTip.value || await canAddTip.value.valid()) authorize()
}, 500)

const checkForm = (success: any, error: any) => {
  if ((model.customerShopUrl && !isUrl(model.customerShopUrl)) || !model.customerShopName) {
    error()
  } else {
    success(model)
  }
  // formRef.value.validate((valid: any) => {
  //   if (valid) {
  //   } else {
  //     error()
  //   }
  // })
}

expose({
  checkForm,
  authorize,
  model
})
shopsList.value.length === 0 && (shopGuideModalVisible.value = true)

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_form, {
    ref: (_value, _refs) => {
      _refs['formRef'] = _value
      _isRef(formRef) && (formRef.value = _value)
    },
    model: _unref(model),
    rules: rules,
    "label-width": "170px",
    key: _unref(model).customerShopPlatform
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        prop: "customerShopPlatform",
        label: _unref(t)('开店平台') + '：'
      }, {
        default: _withCtx(() => [
          _createVNode(CheckRadio, {
            list: _unref(shops).map((i) => { return { name: _unref(t)(i.label), value: i.value, width: 100 } }),
            activeValue: _unref(model).customerShopPlatform,
            "onUpdate:activeValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).customerShopPlatform) = $event)),
            disabled: !_unref(isCreate) && !!_unref(model).customerShopAuthStatus
          
          }, null, 8, ["list", "activeValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_unref(model).customerShopPlatform === 0)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            prop: "customerShopPlatName",
            label: _unref(t)('平台名') + '：'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(model).customerShopPlatName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).customerShopPlatName) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[0]),
                maxlength: 40
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        prop: "customerShopName",
        label: _unref(t)('店铺品牌名') + '：'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: _unref(model).customerShopName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).customerShopName) = $event)),
            placeholder: _unref(t)(tips[1]),
            maxlength: 40
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        prop: "customerShopUrl",
        label: _unref(t)('店铺URL地址') + '：'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: _unref(model).customerShopUrl,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).customerShopUrl) = $event)),
            modelModifiers: { trim: true },
            placeholder: _unref(t)(tips[2]),
            maxlength: 128
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_unref(model).customerShopPlatform === 2)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            prop: "accessToken"
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('访问令牌') + ':') + " ", 1),
              _createVNode(HelpTooltip, {
                tip: _unref(t)('Shopif操作动手册') + '：',
                link: '/' + _unref(usePlat)() + `/help?tab=1&id=${_unref(isD2C)() ? 113 : 9}`
              }, null, 8, ["tip", "link"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _unref(model).accessToken,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).accessToken) = $event)),
                modelModifiers: { trim: true },
                placeholder: _unref(t)(tips[3]),
                maxlength: 100,
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(model).accessToken = _unref(model).accessToken.replaceAll('*', '')))
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!__props.vip)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(model).customerShopPlatform === 4)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : _createCommentVNode("", true),
            (_unref(isMember)() || _unref(model).customerShopPlatform === 11)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_unref(isCreate))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(model).customerShopPlatform !== 0 && _unref(model).customerShopPlatform !== 7)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: _unref(model).customerShopAuthStatus ? _unref(t)('授权状态') + '：' : ''
                            }, {
                              default: _withCtx(() => [
                                (_unref(model).customerShopAuthStatus)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(t)('已授权')), 1))
                                  : (canAuth.value || _unref(model).customerShopPlatform === 3 || _unref(model).customerShopPlatform === 11)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: "a-btn",
                                        onClick: toAuth
                                      }, _toDisplayString(_unref(t)('去授权')) + "> ", 1))
                                    : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              (_unref(isCreate))
                ? (_openBlock(), _createBlock(CanAddTip, {
                    key: 0,
                    ref: (_value, _refs) => {
                      _refs['canAddTip'] = _value
                      canAddTip.value = _value
                    },
                    class: "mr_20"
                  }, null, 512))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_button, {
                  type: "default",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _unref(commit),
                    loading: _unref(loading)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(_unref(isCreate) ? '创建店铺' : '保存店铺')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model"])), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})